import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-leave-project-dialog',
    templateUrl: './leave-project-dialog.component.html',
    styleUrls: ['./leave-project-dialog.component.css'],
    standalone: false,
})
export class LeaveProjectDialogComponent {
    constructor(private dialogRef: MatDialogRef<LeaveProjectDialogComponent>) {}

    leaveVersion() {
        this.dialogRef.close(true);
    }

    cancel() {
        this.dialogRef.close(false);
    }
}
